module.exports = __webpack_public_path__ + "images/1ff6d6048015a1d8343861c33b4207cb.png";